<template>
  <div class="cartpopup">
    <nav>
      <a class="pa3 btn">
        <router-link to="/" active-class="active">
          <v-btn color="#6dbe45" class="btns" style="color: #ffffff">
            <v-icon style="color: #ffffff">keyboard_backspace</v-icon>Start Over
          </v-btn>
        </router-link>
      </a>
      <a
        class="pa3 btn"
        style="color: #00587d"
        id="cart"
        @click.stop="showCart = true"
      >
        <v-btn color="#6dbe45" class="btns" style="color: #ffffff">
          <v-icon style="color: #ffffff">shopping_cart</v-icon>Cart&nbsp;
          <span class="badge">{{ containersListsSize() }}</span>
        </v-btn>
      </a>
    </nav>
    <!-- Main Dialog starts -->
    <v-dialog v-model="showCart" max-width="500px">
      <div class="shopping-cart">
        <div class="shopping-cart-header">
          <h4 style="float: left; font-weight: bold; color: black">
            Shopping Cart
          </h4>
        </div>
        <a
          href="#"
          style="float: right"
          class="button"
          @click="showCart = false"
        >
          <v-icon>close</v-icon>
        </a>
        <br />
        <!--end shopping-cart-header -->
        <div v-if="containersListsSize() >= 1">
          <ul class="shopping-cart-items">
            <li
              class="clearfix"
              style="font-size: 1em"
              v-for="(item, index) in CART"
              :key="index"
            >
              <hr />
              <img :src="item.image" alt="item1" />
              <table>
                <tr colspan="2">
                  <td class="item-name">{{ item.title }}</td>
                </tr>
                <tr>
                  <td class="td-label">Quantity:</td>
                  <td class="item-quantity" style="float: right">
                    {{ item.quantity }}
                  </td>
                </tr>
                <tr>
                  <td class="td-label">Item Price:</td>
                  <td class="item-price" style="float: right">
                    ${{ format(item.price * item.quantity) }}
                  </td>
                </tr>
                <tr>
                  <td class="td-label">Delivery Fee:</td>
                  <td class="item-quantity" style="float: right">
                    ${{
                      getHaulingPrice(
                        item.haulingPrice,
                        item.customAttributes.Delivery,
                        item.quantity
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="td-label" v-if="item.CSCSurvey">CSC Survey:</td>
                  <td
                    class="item-quantity"
                    style="float: right"
                    v-if="item.CSCSurvey"
                  >
                    ${{ format(item.CSCSurvey.price * item.quantity) }}
                  </td>
                </tr>
                <tr>
                  <td class="td-label">Sub-Total:</td>
                  <td class="item-price" style="float: right">
                    {{ getSubTotal(index) }}
                  </td>
                </tr>
              </table>
            </li>
          </ul>
          <hr />
          <div>
            <span class="lighter-text" style="font-size: 1.5em"
              >Total: ${{ getTotal() }}</span
            >
          </div>
          <!-- Buttons -->
          <v-row justify="center">
            <router-link to="/purchase/container/cart" active-class="active">
              <v-btn color="#6dbe45" class="btns" medium dark>Checkout</v-btn>
            </router-link>
            <v-btn
              color="red"
              class="btns"
              medium
              dark
              @click.stop="dialog = true"
              >Clear Cart</v-btn
            >
            <!-- confirmation dialog start -->
            <v-dialog v-model="dialog" max-width="400">
              <v-card>
                <v-card-title class="headline">PLEASE CONFIRM</v-card-title>
                <v-card-text style="font-size: 20px; text-align: left"
                  >Clear everything from the cart?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-10" text @click="dialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click.prevent="deleteAll()"
                    >Yes</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- confirmation dialog end-->
        </div>
        <div v-else>
          <br />
          <br />
          <p style="color: black">Cart is empty</p>
        </div>
      </div>
      <!--end shopping-cart -->
    </v-dialog>
    <!--end container -->
  </div>
</template>

<script>
import { formatNumber } from "@/JS/FormatNumber";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "CartPopup",
  computed: {
    ...mapGetters({
      CART: types.CART_LIST,
    }),
  },
  data() {
    return {
      showCart: false,
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      resetCart: types.ACTIONS_UPDATE_RESETCART,
    }),
    containersListsSize() {
      return this.CART.length;
    },
    deleteAll() {
      this.resetCart();
      this.dialog = false;
      this.showCart = false;
      this.localStorageCart();
    },
    getSubTotal(index) {
      let subTotal = this.computePrice(index);
      return "$" + formatNumber(subTotal);
    },
    computePrice(index) {
      var sum = this.CART[index]["price"];

      if ("CSCSurvey" in this.CART[index])
        sum += parseInt(this.CART[index]["CSCSurvey"]["price"]);
      if (this.CART[index]["customAttributes"]["Delivery"] === "DELIVERY")
        sum += parseInt(this.CART[index]["haulingPrice"]);

      return this.CART[index]["quantity"] * sum;
    },
    getTotal() {
      var total = 0;
      for (var index in this.CART) total += this.computePrice(index);

      return formatNumber(total);
    },
    globalContainersListSize() {
      return this.CART.length > 0;
    },
    getHaulingPrice(price, delivery, quantity) {
      return delivery === "DELIVERY" ? formatNumber(price * quantity) : "0";
    },
    localStorageCart() {
      const containerdetailes = JSON.stringify(this.CART);
      localStorage.setItem("containerdetailes", containerdetailes);
    },
    format(num) {
      return formatNumber(num);
    },
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);

.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  box-shadow: 1px 1px 1px 1px #ffffff;
  margin: 10px;
}

a {
  text-decoration: none !important;
}
nav {
  padding: 10px 0 30px 0;
}

.lighter-text {
  color: black;
}

nav .li {
  display: inline;
}

.badge {
  background-color: #00587d;
  border-radius: 10px;
  margin-left: 10px;
  color: white;
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 3px 9px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

.shopping-cart {
  background: #f4f4f4;
  border-radius: 15px;
  padding: 10px;
  z-index: 1;
}

.shopping-cart-items {
  padding-top: 0.5em;
}

.shopping-cart-items .li {
  margin-bottom: 18px;
}

.shopping-cart-items img {
  max-width: 35%;
  max-height: 35%;
  display: block;
  float: left;
  border-radius: 10%;
}

.shopping-cart-items .item-name {
  display: block;
  padding-top: 10px;
  color: #1f1d1d;
  text-align: center;
  font-size: 20px;
  padding: 5px;
}

.item-price {
  color: black;
  text-align: left;
}

.item-quantity {
  color: black;
  text-align: left;
}

.shopping-cart::after {
  bottom: 100%;
  left: 89%;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: white;
  border-width: 8px;
  margin-left: 0;
}

hr {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  border-width: 2px;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

ul {
  list-style-type: none;
}

.td-label {
  width: 100%;
  text-align: right;
  padding-right: 30px;
}

.btn {
  padding: 5px;
}

@media only screen and (max-width: 490px) and (min-width: 420px) {
  #item-name {
    font-size: 100%;
  }

  h4 {
    font-size: 100%;
  }

  .lighter-text {
    font-size: 18px;
  }

  v-btn,
  td {
    font-size: 80%;
  }
}

@media only screen and (max-width: 420px) {
  #item-name {
    font-size: 50%;
  }

  .lighter-text {
    font-size: 16px;
  }

  td {
    font-size: 80%;
  }

  h4,
  v-btn {
    font-size: 100%;
  }

  img {
    width: 50%;
  }
}
</style>